/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import GenericTable from "../../components/GenericTable";
import GenericModal from "../../components/GenericModal";
import { Button, Checkbox, Form, Icon, Input, InputNumber, message } from "antd";
import CustPicker from "../../components/CustPicker";
import GenericSelector from "../../components/GenericSelector";
import SelectorItemClassic from "../../components/SelectorItemClassic";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import DateTimePicker from "../../components/DateTimePicker"
import moment from "moment";
import TableLineIcons from "../../components/TableLineIcons";

class AutoServiceCalls extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {

        };

        this.id = "AUTO_SERVICE_CALLS";

        this.api = {
            get: "get_auto_service_calls",
            create_edit: "create_edit_auto_service_calls",
        }

        this.selectors = [
            { id: "SERVICE_SUBJECT_DETAILS_LIST", api: "service_subject_details_list" },
            { id: "CUSTOMER_BUSINESS_BRANCHES_LIST", api: "customer_business_branches_list" },
            { id: "SERVICE_SUBJECTS_TAGS_AND_USERS", api: "get_service_subjects_tags_and_users" },
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        this.selectors.forEach(x => { if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector } });

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {

        const { id, api } = this.selectors[2]

        this.sendAPI(api, "", (ob) => {
            let dataset = ob.data ? ob.data.split("\r").map(x => {
                let y = x.split("\f")
                return {
                    subjectDetailId: y[0],
                    tagId: y[1],
                    tagName: y[2],
                    userId: y[3],
                    userName: y[4],
                }
            }) : []
            this.props.dataActions.setJson(id, { dataset })
        })
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(20936);
    }

    handleCancel = () => {
        const { editing } = this.props.data[this.id]
        if (editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id);
        else this.props.dataActions.genericDataCancelEditing(this.id);
    }

    handleOk = () => {
        const { editedRecord } = this.props.data[this.id]
        if (
            ['aCustomerID', 'aSubjectDetailID', 'aDesc', 'aDuration', 'aTimes', 'aWhen'].find(f => !editedRecord[f])
            || (!editedRecord.aTargetUserID && !editedRecord.aTargetUserTagID)
        ) {
            message.error(this.getText(20994))
        } else {

            this.props.dataActions.genericDataSaveEdit(
                this.id, this.props.user.companyCode, this.props.user.token,
                this.api.create_edit, this.api.get);
        }
    }

    apiCustBranches = (cust) => {
        const { id, api } = this.selectors[1]
        this.props.dataActions.genericSelectorRefreshDataset(
            id, this.props.user.companyCode, this.props.user.token, api, { cust });
    }

    getUsersDataset = (isTags, sdId) => {
        let dataset = [];
        let codeField = isTags ? "tagId" : "userId"
        let nameField = isTags ? "tagName" : "userName"
        const { editedRecord } = this.props.data[this.id]
        let subjectDetailId = sdId ? sdId : editedRecord.aSubjectDetailID
        this.props.data[this.selectors[2].id].dataset.forEach(x => {
            if (subjectDetailId == x.subjectDetailId && !dataset.find(f => f.code == x[codeField]))
                dataset.push({ code: x[codeField], name: x[nameField] })
        })
        return dataset
    }

    textareaWithTranslation = (value, onChange) => {
        return (<div className="textarea-wrapper" style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
            <Input.TextArea
                style={{ paddingRight: 40 }}
                rows={6}
                value={value}
                onChange={e => { onChange(e.target.value) }}
            />
            <Icon
                style={{
                    position: 'absolute',
                    right: 12,
                    top: 12,
                    fontSize: 18,
                    color: '#aaa',
                    cursor: 'pointer',
                }}
                type="font-colors"
                onClick={() => {
                    const enChars = "qwertyuiopasdfghjkl;'zxcvbnm,./".split("");
                    const heChars = "/'קראטוןםפשדגכעיחלךף,זסבהנמצתץ.".split("");
                    let isHe = new RegExp(/[א-ת]/).test(value)
                    onChange(value?.split("").map(x => {
                        return (isHe ? enChars[heChars.findIndex(f => f == x)] : heChars[enChars.findIndex(f => f == x)]) ?? x
                    }).join("") ?? "")
                }} />
        </div>)
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    getDayName = (day) => {
        switch (day) {
            case '1': return this.getText(20962)
            case '2': return this.getText(20963)
            case '3': return this.getText(20964)
            case '4': return this.getText(20965)
            case '5': return this.getText(20966)
            case '6': return this.getText(20967)
            case '7': return this.getText(20968)
        }
    }

    getDurationDataset = () => {
        return [
            { code: '1', name: this.getText(20958) },
            { code: '2', name: this.getText(20959) },
            { code: '3', name: this.getText(20960) },
            { code: '4', name: this.getText(20961) },
        ]
    }


    editField = (field) => {
        const gt = this.getText
        const { editing, editedRecord } = this.props.data[this.id]
        const value = editedRecord[field]
        const valueWhen = editedRecord.aWhen
        const onChange = e => { this.props.dataActions.genericDataSetEdit(this.id, { [field]: e }) }
        const onChangeWhen = e => { this.props.dataActions.genericDataSetEdit(this.id, { aWhen: e }) }

        switch (field) {
            case 'aCustomerID':
                return (<CustPicker {...this.props} defaultView={gt(12121)} value={value} onChange={e => {
                    onChange(e)
                    this.apiCustBranches(e)
                }} />)
            case 'aBranchID':
                return (<GenericSelector {...this.props} id={this.selectors[1].id} {...{ value, onChange }} />)
            case 'aSubjectDetailID':
                return (<GenericSelector {...this.props} {...this.selectors[0]} {...{ value, onChange }} />)
            case 'aCallerName': case 'aCallerTel1': case 'aCallerTel2': case 'aDesc': case 'aItemSN':
                return (<Input value={value} onChange={e => { onChange(e.target.value) }} />)
            case 'aRemarks':
                return this.textareaWithTranslation(value, onChange)
            case 'aItemCode':
                return (<SelectorItemClassic {...this.props} valueId={value} valueName={editedRecord.aItemName}
                    onChange={(aItemCode, aItemName) => { this.props.dataActions.genericDataSetEdit(this.id, { aItemCode, aItemName }) }} />)
            case 'aTargetUserID':
                return (<GenericSelector {...this.props} value={value} dataset={this.getUsersDataset()} onChange={e => {
                    this.props.dataActions.genericDataSetEdit(this.id, { aTargetUserID: e, aTargetUserTagID: "" })
                }} />)
            case 'aTargetUserTagID':
                return (<GenericSelector {...this.props} value={value} dataset={this.getUsersDataset(true)} onChange={e => {
                    this.props.dataActions.genericDataSetEdit(this.id, { aTargetUserID: "", aTargetUserTagID: e })
                }} />)
            case 'aDuration':
                return (<GenericSelector {...this.props} value={value} dataset={this.getDurationDataset()} onChange={e => {
                    onChange(e)
                    onChangeWhen('')
                }} />)
            case 'aTimes':
                return (<InputNumber  {...{ value, onChange }} />)
            case 'aCount':
                return value
            case 'aWhen1':
                return "1234567".split("").map(day => {
                    return (<Checkbox checked={valueWhen?.split(',').find(f => f == day) ? true : false} onChange={e => {
                        let newValue = valueWhen ? valueWhen.split(',') : []
                        if (e.target.checked) newValue.push(day)
                        else newValue = newValue.filter(f => f != day)
                        onChangeWhen(newValue ? newValue.join(",") : "")
                    }} >{this.getDayName(day)}</Checkbox>)
                })
            case 'aWhen2':
                let list = "1234567".split("").map(day => { return { code: day, name: this.getDayName(day) } })
                return (<GenericSelector {...this.props} value={valueWhen} dataset={list} onChange={onChangeWhen} />)
            case 'aWhen3':
                return (<InputNumber value={valueWhen} min={1} max={31} onChange={onChangeWhen} />)
            case 'aWhen4':
                return (<DateTimePicker
                    value={valueWhen ? moment(valueWhen, "DDMM").format("YYYY-MM-DD") : null}
                    onChange={e => { onChangeWhen(e ? moment(e).format("DDMM") : null) }}
                    format="DD/MM" />)
            case 'aNext':
                return value ? moment(value).format("DD/MM/YYYY") : ""
        }
    }

    renderEditCol = (t, record) => {
        return (<TableLineIcons
            onEdit={() => {
                this.props.dataActions.genericDataStartEditing(this.id, record.key, record.index)
                this.apiCustBranches(record.aCustomerID)
            }}
        />
        )
    }

    render() {
        const gt = this.getText;
        const render = t => t
        const renderDuration = t => this.getDurationDataset().find(f => f.code == t)?.name
        const renderWhen = (t, r) => {
            switch (r.aDuration) {
                case '1': return `${gt(20991)} ${t?.split(",").map(x => this.getDayName(x))}`
                case '2': return `${gt(20992)} ${this.getDayName(t)}`
                case '3': return `${t} ${gt(20993)}`
                case '4': return t ? moment(t, "DDMM").format("DD/MM") : null
            }
        }
        const sorter = true
        const { editing, editedRecord } = this.props.data[this.id]
        const validProps = (v, d) => { return d && d.length ? {} : { required: true, validateStatus: !v ? "error" : "success" } }
        const spanProps = { labelCol: { span: 10 }, wrapperCol: { span: 14 } }
        const divStyle = {
            align: "center",
            dir: "rtl", // dir: "ltr"
            padding: "2% 2% 2% 2%",
        };

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                title={gt(20937)}
                rowsFilter={r => r.key > 0}
                id={this.id}
                getApi={this.api.get}
                addButton={() => { this.props.dataActions.genericDataStartInlineCreate(this.id) }}
                columns={[
                    { title: gt(20938), key: "aID", dataIndex: "aID", width: "5%", sorter, render },
                    { title: gt(20939), key: "aCustomerID", dataIndex: "aCustomerID", width: "5%", sorter, render },
                    { title: gt(20940), key: "aCustomerName", dataIndex: "aCustomerName", width: "10%", sorter, render },
                    { title: gt(20941), key: "aBranchName", dataIndex: "aBranchName", width: "10%", sorter, render },
                    { title: gt(20942), key: "aCallerName", dataIndex: "aCallerName", width: "10%", sorter, render },
                    { title: gt(20943), key: "aCallerTel1", dataIndex: "aCallerTel1", width: "7%", sorter, render },
                    { title: gt(20944), key: "aCallerTel2", dataIndex: "aCallerTel2", width: "7%", sorter, render },
                    { title: gt(20945), key: "aSubjectDetailDesc", dataIndex: "aSubjectDetailDesc", width: "10%", sorter, render },
                    { title: gt(20946), key: "aDesc", dataIndex: "aDesc", width: "10%", sorter, render },
                    { title: gt(20947), key: "aDuration", dataIndex: "aDuration", width: "7%", sorter, render: renderDuration },
                    { title: gt(20948), key: "aWhen", dataIndex: "aWhen", width: "12%", sorter, render: renderWhen },
                    { title: gt(20949), width: "5%", render: this.renderEditCol },
                ]} />

            <GenericModal
                visible={editing > -1}
                onCancel={this.handleCancel}
                title={editing == 0 ? gt(20952) : `${gt(20953)} ${editedRecord?.aID}`}
                footer={[
                    <Button key={"back"} onClick={this.handleCancel} style={{ margin: 5 }}>{gt(20906)}</Button>,
                    <Button key={"create"} type={"primary"} onClick={this.handleOk} style={{ margin: 5 }}>{gt(20907)}</Button>,
                ]}>
                <Form
                    style={{ columnCount: window.innerWidth < 600 ? 1 : 3, columnGap: 70 }}
                    labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}
                >
                    <Form.Item label={gt(20969)} {...validProps(editedRecord.aCustomerID)}>{this.editField('aCustomerID')}</Form.Item>
                    <Form.Item label={gt(20970)}>{this.editField('aBranchID', 3)}</Form.Item>
                    <Form.Item label={gt(20971)}>{this.editField('aCallerName')}</Form.Item>
                    <Form.Item label={gt(20972)}>{this.editField('aCallerTel1')}</Form.Item>
                    <Form.Item label={gt(20973)}>{this.editField('aCallerTel2')}</Form.Item>
                    <Form.Item label={gt(20974)} {...validProps(editedRecord.aSubjectDetailID)}>{this.editField('aSubjectDetailID')}</Form.Item>
                    <Form.Item label={gt(20975)} {...validProps(editedRecord.aDesc)}>{this.editField('aDesc')}</Form.Item>
                    <Form.Item label={gt(20976)}>{this.editField('aRemarks')}</Form.Item>
                    <Form.Item label={gt(20977)}>{this.editField('aItemCode')}</Form.Item>
                    <Form.Item label={gt(20978)}>{this.editField('aItemSN')}</Form.Item>
                    <Form.Item label={gt(20979)} {...spanProps} {...validProps(editedRecord.aTargetUserID, editedRecord.aTargetUserTagID)}>{this.editField('aTargetUserID')}</Form.Item>
                    <Form.Item label={gt(20980)} {...spanProps} {...validProps(editedRecord.aTargetUserTagID, editedRecord.aTargetUserID)}>{this.editField('aTargetUserTagID')}</Form.Item>
                    <Form.Item label={gt(20981)} {...spanProps} {...validProps(editedRecord.aDuration)}>{this.editField('aDuration')}</Form.Item>
                    <Form.Item label={gt(20982)} {...spanProps} {...validProps(editedRecord.aTimes)}>{this.editField('aTimes')}</Form.Item>
                    <Form.Item label={gt(20983)} {...spanProps}>{this.editField('aCount')}</Form.Item>
                    {editedRecord.aDuration == '1' ? <Form.Item label={gt(20984)} {...spanProps} {...validProps(editedRecord.aWhen)}>{this.editField('aWhen1')}</Form.Item>
                        : editedRecord.aDuration == '2' ? <Form.Item label={gt(20985)} {...spanProps} {...validProps(editedRecord.aWhen)}>{this.editField('aWhen2')}</Form.Item>
                            : editedRecord.aDuration == '3' ? <Form.Item label={gt(20986)} {...spanProps} {...validProps(editedRecord.aWhen)}>{this.editField('aWhen3')}</Form.Item>
                                : editedRecord.aDuration == '4' ? <Form.Item label={gt(20987)} {...spanProps} {...validProps(editedRecord.aWhen)}>{this.editField('aWhen4')}</Form.Item>
                                    : <Form.Item></Form.Item>}
                    <Form.Item label={gt(20988)} {...spanProps}>{this.editField('aNext')}</Form.Item>
                </Form>
            </GenericModal>
        </div>)
    }

}

export default AutoServiceCalls;